import Vue from 'vue'

import VueRouter from 'vue-router'

import Login from '@/views/Login.vue'

import Home from '@/views/Home.vue'

import wsManager from '@/utils/websocket'

import {

  bindRouter,

  resetDynamicRoutesFlag,

  isDynamicRoutesAdded,

  registerDynamicRoutes

} from './routeRegistry'



Vue.use(VueRouter)



const constantRoutes = [

  {

    path: '/',

    redirect: '/login'

  },

  {

    path: '/login',

    name: 'Login',

    component: Login,

    meta: { title: '登录' }

  },

  {

    path: '/MakeBooking',

    name: 'MakeBooking',

    component: () => import('@/views/order/bookingOrder/MakeBooking.vue'),

    meta: { title: '订舱', requiresAuth: true, standalone: true }

  },

  {

    path: '/OrderDetails',

    name: 'OrderDetails',

    component: () => import('@/views/order/bookingOrder/orderDetails.vue'),

    meta: { title: '订单详情', requiresAuth: true, standalone: true }

  },

  {

    path: '/ScheduleTrendDetail',

    name: 'ScheduleTrendDetail',

    component: () => import('@/views/management/ScheduleTrendDetail.vue'),

    meta: { title: '走势详情', requiresAuth: true, standalone: true }

  },

  {

    path: '/DataQueryDetail',

    name: 'DataQueryDetail',

    component: () => import('@/views/management/DataQueryDetail.vue'),

    meta: { title: '数据查看', requiresAuth: true, standalone: true }

  },

  {

    path: '/home',

    name: 'Home',

    component: Home,

    meta: { title: '首页', requiresAuth: true }

  }

]



const router = new VueRouter({

  mode: 'history',

  base: process.env.BASE_URL,

  routes: constantRoutes

})



bindRouter(router)



let wsInitPromise = null

function initWebSocket(token) {

  if (!token) return Promise.resolve()

  if (wsManager.isConnected() && wsManager.isLogin()) {

    return Promise.resolve()

  }

  if (wsInitPromise) {

    return wsInitPromise

  }

  wsInitPromise = wsManager.init()

    .then(() => {

      wsManager.login(token)

    })

    .catch(error => {

      console.error('WebSocket初始化失败:', error)

    })

    .finally(() => {

      setTimeout(() => {

        wsInitPromise = null

      }, 1000)

    })

  return wsInitPromise

}



router.beforeEach(async (to, from, next) => {

  if (to.meta.title) {

    document.title = to.meta.title + ' - 船期管理系统'

  }

  const token = localStorage.getItem('token')

  if (to.path === '/login') {

    resetDynamicRoutesFlag()

    wsManager.logout()

    next()

    return

  }

  if (!token) {

    wsManager.logout()

    return next('/login')

  }

  if (!to.meta.standalone) {

    initWebSocket(token)

  }

  if (!isDynamicRoutesAdded()) {

    await registerDynamicRoutes()

    return next({ ...to, replace: true })

  }

  next()

})



export default router

export { resetDynamicRoutesFlag, registerDynamicRoutes }


